import PulseModule from "components/modules/Pulse";
import React, { useEffect } from "react";
import { useAppDispatch } from "store/hooks";
import { setCurrentPage } from "store/slices/ui.slice";
import constants from "utils/constants";

export const WebsiteVisitors: React.FC<{ formEnrichment: boolean }> = ({ formEnrichment }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.analytics.page("WebsiteVisitors");
    dispatch(setCurrentPage(constants.PIXEL_KEYWORD));
  }, []);
  return <PulseModule formEnrichment={formEnrichment} />
};
